import { lazy } from 'react';

// Lazy-Load heavy components (Below-the-Fold)
export const CoverageCards = lazy(() => import('@/components/CoverageCards'));
export const ExpertSection = lazy(() => import('@/components/ExpertSection'));
export const CyberThreatsCards = lazy(() => import('@/components/CyberThreatsCards'));
export const CTASection = lazy(() => import('@/components/CTASection'));
